import { useT } from '@/shared/i18n'

interface FilePickPromptProps {
  /** Desktop drag hint. Touch screens see a plain "choose a file" action instead. */
  drag: string
  /** `drag` is a complete sentence, so the "click to choose" suffix is not appended. */
  complete?: boolean
}

export function FilePickPrompt({ drag, complete = false }: FilePickPromptProps) {
  const t = useT()
  return (
    <>
      <span className="text-primary sm:hidden">{t.common.pickFile}</span>
      <span className="hidden sm:inline">
        {drag}
        {!complete && (
          <span className="text-primary underline-offset-2 hover:underline">
            {t.common.clickToPick}
          </span>
        )}
      </span>
    </>
  )
}
